// Site bilgileri ve sabitler
export const SITE_INFO = {
  name: "Nish Global Mühendislik",
  contact: {
    address: "K.Bakkalköy Mh. Dereboyu Cd. Brandium Office Center, R5 Blok, No:48 Ataşehir - İstanbul - Türkiye",
    phone: [
      { number: "+90 216 807 27 27", label: "headquarters" },
      { number: "+90 540 807 27 27", label: "projectManagement" }
    ],
    email: ["nish@nishglobal.tr"]
  }
};

// Header menü başlıkları (orijinal siteden)
export const MENU_ITEMS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Technical Articles", path: "/technical-articles" },
  { label: "References", path: "/references" },
  { label: "Contact", path: "/contact" }
];

// Renk paleti (site analizinden)
export const COLORS = {
  primary: "#1a1a1a", // Koyu gri/siyah
  secondary: "#2c2c2c", // Orta gri
  accent: "#d4af37", // Altın sarısı (prestijli görünüm için)
  text: {
    primary: "#333333",
    secondary: "#666666",
    light: "#ffffff"
  },
  background: {
    light: "#ffffff",
    dark: "#1a1a1a",
    gray: "#f5f5f5"
  },
  border: "#e0e0e0"
};

